export const adminUserStyles = {
    adminCheckBoxStyle: {
        color: '#000',
        '& .MuiSvgIcon-root':
            { fontSize: 24 }
    },
    tableCellStyle: {
        padding: 1,
        lineHeight: 1.6,
        color: '#000',
    }
}